import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.329 2.148a.835.835 0 0 1 .821-.683h6.4a.835.835 0 0 1 .773 1.15l-1.682 4.132H15.2a.835.835 0 0 1 .662 1.344l-7.85 10.218a.835.835 0 0 1-1.478-.686l1.1-5.074a.835.835 0 0 1 1.632.354l-.312 1.438 4.552-5.924H10.4a.835.835 0 0 1-.773-1.15l1.682-4.132H6.845L5.703 9.312H9a.835.835 0 1 1 0 1.67H4.7a.835.835 0 0 1-.821-.987z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }